import { validateEmail } from '../functions/validateEmail';

const Validate = (function() {
  const messages = {
    required: 'Please enter a value.',
    email: {
      invalid: 'Please enter a valid email address.',
      duplicate: 'Email addresses entered do not match.'
    }
  };

  let checked = false;
  let success = true;
  let store = [];

  function _addInlineError(elem, message) {
    if (!elem) return;

    const row = elem.closest('.form__row');
    const target = row.querySelector('.form__error');
    const error = elem.getAttribute('data-required-error');

    // add error class
    row.classList.add('has-error');

    // insert error message, show error
    if (target && target.classList.contains('form__error')) {
      target.innerHTML = message ? message : error;
      target.style.display = 'block';
    }
  }

  function _removeInlineError(elem) {
    if (!elem) return;

    const row = elem.closest('.form__row');
    const target = row.querySelector('.form__error');

    // remove error class
    row.classList.remove('has-error');

    // remove error message, hide error
    if (target && target.classList.contains('form__error')) {
      target.innerHTML = '';
      target.style.display = 'none';
    }
  }

  function _pushField(elem) {
    const field = {};

    field.type = elem.type;
    field.name = elem.getAttribute('name');
    field.required = elem.getAttribute('data-required') !== null ? true : false;

    if (elem.type === 'radio' || elem.type === 'checkbox') {
      field.value = elem.checked;
    } else {
      field.value = elem.value;
    }

    store.push(field);
  }

  function _createStore(form) {
    const { elements } = form;

    // clear store
    store = [];

    // loop form elements and push fields
    let name;

    for (let i = 0; i < elements.length; i += 1) {
      if (elements[i].type === 'checkbox' || elements[i].type === 'radio') {
        // only push first instance of checkbox / radio
        if (elements[i].name !== name) {
          _pushField(elements[i]);
        }
        name = elements[i].name;
      } else if (elements[i].type !== 'hidden') {
        _pushField(elements[i]);
      }
    }
  }

  function _checkUserInput(form) {
    store.forEach(entry => {
      const field = form.querySelector(`[name="${entry.name}"]`);

      // remove any existing error message
      _removeInlineError(field);

      const loopThroughInput = (entry, type) => {
        if (entry.required && entry.type === type) {
          const input = form.querySelectorAll(`[name="${entry.name}"]`);

          checked = false;

          for (let i = 0; i < input.length; i += 1) {
            if (input[i].checked) {
              checked = true;
              _removeInlineError(field);
            }

            if (!checked) {
              _addInlineError(field);
            }
          }
        }
      };

      // radio
      loopThroughInput(entry, 'radio');

      // checkbox
      loopThroughInput(entry, 'checkbox');

      // rmail
      if (entry.required && entry.type === 'email') {
        // valid email address
        if (!validateEmail(entry.value)) {
          _addInlineError(field, messages.email.invalid);
        }

        // check if email addresses match
        for (let i = 0; i < store.length; i += 1) {
          if (store[i].type === 'email') {
            if (store[i].value !== entry.value) {
              _addInlineError(field, messages.email.duplicate);
            }
          }
        }
      }

      // check if input empty
      if (entry.required && entry.value.length === 0) {
        _addInlineError(field);
      }
    });

    // update success depending on .has-error instances
    const hasError = document.querySelectorAll('.has-error');
    success = hasError.length > 0 ? false : true;

    // success && form.classList.add('is-valid');
  }

  function fetchStore() {
    console.log('store', store);
    return store;
  }

  function parseForm(form) {
    if (form.tagName.toLowerCase() !== 'form') {
      throw new Error(`
        Error parsing form, the following must be passed as a function parameter:
        HTMLFormElement instance or submit event.target
      `);
    }

    _createStore(form);
    _checkUserInput(form);

    return success;
  }

  return {
    fetchStore: fetchStore,
    parseForm: parseForm
  };
})();

export default Validate;
